var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { ModelsClient, ManufacturersClient, LookupsClient, CompaniesClient, Model, ComponentTypeEnum, ManufacturerTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import RouteNames from "@/app/router/routes";
import "@/app/component-hooks";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const modelsClient = new ModelsClient(window.apiUrl);
const manufacturersClient = new ManufacturersClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
const companiesClient = new CompaniesClient(window.apiUrl);
let ModelVue = class ModelVue extends Vue {
    constructor() {
        super(...arguments);
        this.companyId = 0;
        this.manufacturerId = 0;
        this.manufacturerIdFromRoute = 0;
        this.manufacturerTypeId = null;
        this.modelId = 0;
        this.loaded = false;
        this.working = false;
        this.attemptedSave = false;
        this.priceInputValue = '';
        this.currencyCode = '';
        this.msg = new Alert();
        this.model = new Model();
        this.manufacturers = [];
    }
    created() {
        this.companyId = parseInt(this.$route.params.companyId) || 0;
        this.manufacturerIdFromRoute = parseInt(this.$route.params.manufacturerId) || 0;
        this.modelId = parseInt(this.$route.params.id) || 0;
        this.getLookups();
        this.get();
    }
    ;
    get() {
        if (this.isNewModel) {
            let model = new Model();
            model.init({});
            this.map(model);
            // Initialize price input value for new model
            this.priceInputValue = '';
            this.loaded = true;
            return;
        }
        this.working = true;
        modelsClient
            .get(this.modelId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.loaded = true;
            this.map(response);
            // Initialize price input value with 2 decimal places
            this.priceInputValue = response.price != null ? response.price.toFixed(2) : '';
            this.setValues({
                name: this.model.modelName,
                price: this.model.price
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getLookups() {
        let promises = [
            lookupsClient
                .getManufacturers(this.companyId)
                .then(response => {
                this.manufacturers = (response || []).map(m => ({
                    value: m.manufacturerId,
                    text: m.manufacturerName || ""
                }));
            })
        ];
        Promise.all(promises)
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getCompanyCurrency() {
        if (!this.companyId || !this.isBatteryModel)
            return;
        companiesClient
            .get(this.companyId)
            .then(response => {
            if (response && response.currencyCode) {
                this.currencyCode = response.currencyCode;
            }
        })
            .catch(ex => {
            // Silently fail - currency is optional
            console.warn('Could not fetch company currency', ex);
        });
    }
    ;
    map(model) {
        this.model = model;
        this.model.companyId = this.companyId;
        if (this.manufacturerIdFromRoute === 0) {
            // Controller model - no manufacturer
            this.model.manufacturerId = null;
            this.model.componentTypeId = ComponentTypeEnum.Controller;
            this.model.price = null;
        }
        else if (this.manufacturerIdFromRoute > 0) {
            // Battery model from manufacturer page
            this.model.manufacturerId = this.manufacturerIdFromRoute;
            this.manufacturerId = this.manufacturerIdFromRoute;
            this.setComponentTypeFromManufacturer();
        }
        else {
            // Existing model - determine type from current manufacturer
            this.setComponentTypeFromManufacturer();
        }
    }
    ;
    onManufacturerChanged() {
        this.setComponentTypeFromManufacturer();
    }
    onBatteryModelChanged() {
        // When switching to/from battery model, initialize or clear price display
        if (this.isBatteryModel && this.model.price != null) {
            this.priceInputValue = this.model.price.toFixed(2);
        }
        else if (!this.isBatteryModel) {
            this.priceInputValue = '';
        }
    }
    onPriceInput(event) {
        var _a;
        // Allow only numbers, one decimal point, and up to 2 decimal places
        let value = ((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || '';
        // Remove any non-numeric characters except decimal point
        value = value.replace(/[^\d.]/g, '');
        // Ensure only one decimal point
        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
        }
        // Limit to 2 decimal places
        if (parts.length === 2 && parts[1].length > 2) {
            value = parts[0] + '.' + parts[1].substring(0, 2);
        }
        // Update the input value if it was modified by validation
        if (value !== event.target.value) {
            this.priceInputValue = value;
            // Force update the input element
            this.$nextTick(() => {
                if (event.target) {
                    event.target.value = value;
                }
            });
        }
    }
    onPriceBlur() {
        // Format to always show 2 decimal places on blur
        if (this.priceInputValue === '' || this.priceInputValue === null || this.priceInputValue === '.') {
            this.model.price = null;
            this.priceInputValue = '';
            // Update vee-validate field value
            this.setFieldValue('price', null);
        }
        else {
            const numValue = parseFloat(this.priceInputValue);
            if (isNaN(numValue) || numValue < 0) {
                this.model.price = null;
                this.priceInputValue = '';
                // Update vee-validate field value
                this.setFieldValue('price', null);
            }
            else if (numValue > 1000000) {
                this.model.price = 1000000;
                this.priceInputValue = '1000000.00';
                // Update vee-validate field value
                this.setFieldValue('price', 1000000);
            }
            else {
                // Round to 2 decimal places
                this.model.price = Math.round(numValue * 100) / 100;
                // Format with 2 decimal places
                this.priceInputValue = this.model.price.toFixed(2);
                // Update vee-validate field value with the numeric value
                this.setFieldValue('price', this.model.price);
            }
        }
    }
    setComponentTypeFromManufacturer() {
        if (!this.model.manufacturerId) {
            // Controller model - no manufacturer
            this.model.componentTypeId = ComponentTypeEnum.Controller;
            this.manufacturerTypeId = null;
            return;
        }
        // Get the manufacturer details to determine type
        manufacturersClient
            .get(this.model.manufacturerId)
            .then(manufacturer => {
            if (!manufacturer)
                return;
            // Store manufacturer type
            this.manufacturerTypeId = manufacturer.manufacturerTypeId;
            // Battery manufacturer = String component type
            // Charger/UPS manufacturer = Controller component type
            if (manufacturer.manufacturerTypeId === ManufacturerTypeEnum.Battery) {
                this.model.componentTypeId = ComponentTypeEnum.String;
            }
            else if (manufacturer.manufacturerTypeId === ManufacturerTypeEnum.ChargerUPS) {
                this.model.componentTypeId = ComponentTypeEnum.Controller;
            }
            this.getCompanyCurrency();
        });
    }
    save() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            // Clear price for non-battery models
            if (!this.isBatteryModel) {
                this.model.price = null;
            }
            let promise = () => {
                return this.isNewModel
                    ? modelsClient.create(this.model)
                    : modelsClient.update(this.model.modelId, this.model);
            };
            promise()
                .then(response => {
                this.modelId = response;
                Notifier.onOk();
                this.get();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all details.");
        });
        handleSubmitAction();
    }
    ;
    deleteModel() {
        if (this.working || this.isNewModel)
            return;
        this.$confirmModal.show("Are you sure that you want to delete this model?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            modelsClient
                .delete(this.model.modelId)
                .then(() => {
                Notifier.onOk(`Model ${this.model.modelName} has been successfully deleted.`);
                this.goBack();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    goBack() {
        if (this.manufacturerIdFromRoute === 0) {
            // Controller model - go back to manufacturers page with controllers view
            this.$router.push({ name: RouteNames.Manufacturers, params: { companyId: this.companyId } });
        }
        else if (this.manufacturerIdFromRoute > 0) {
            // Battery model - go back to manufacturer detail page
            this.$router.push({ name: RouteNames.Manufacturer, params: { companyId: this.companyId, id: this.manufacturerIdFromRoute } });
        }
        else {
            this.$router.back();
        }
    }
    ;
    get pageTitle() {
        if (this.isNewModel) {
            return this.isControllerModel ? "New Controller Model" :
                this.isBatteryModel ? "New Battery Model" : "New UPS/Charger Model";
        }
        return this.model.modelName;
    }
    ;
    get isNewModel() {
        return !this.modelId;
    }
    ;
    get isControllerModel() {
        return this.manufacturerIdFromRoute === 0;
    }
    ;
    get manufacturer() {
        return this.manufacturers.filter(item => {
            return item.value == this.model.manufacturerId;
        })[0] || null;
    }
    ;
    set manufacturer(item) {
        if (!this.model)
            return;
        this.model.manufacturerId = item === null || item === void 0 ? void 0 : item.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get isBatteryModel() {
        return this.manufacturerTypeId === ManufacturerTypeEnum.Battery;
    }
    ;
};
__decorate([
    Watch("model.manufacturerId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ModelVue.prototype, "onManufacturerChanged", null);
__decorate([
    Watch("isBatteryModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ModelVue.prototype, "onBatteryModelChanged", null);
ModelVue = __decorate([
    Component({
        name: "ModelVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds, setFieldValue, setValues } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                    price: yup.number().nullable().min(0, 'Price cannot be negative').max(1000000, 'Price cannot exceed 1,000,000'),
                }),
            });
            const nameVal = defineInputBinds('name');
            const priceVal = defineInputBinds('price');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                setValues,
                nameVal,
                priceVal
            };
        }
    })
], ModelVue);
export default ModelVue;
